/* sg-bestsellers: carrusel con indicador de página y contador de las tarjetas con estrella. */
if (!customElements.get('sg-bestsellers')) {
  class SgBestsellers extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sg-bs-track]');
      this.prev = this.querySelector('[data-sg-bs-prev]');
      this.next = this.querySelector('[data-sg-bs-next]');
      this.dots = this.querySelector('[data-sg-bs-dots]');
      this.current = this.querySelector('[data-sg-bs-current]');
      this.total = this.querySelector('[data-sg-bs-total]');
      this.pages = 1;

      this.prev.addEventListener('click', () => this.go(-1));
      this.next.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this.track);
      this.build();

      this.end = this.dataset.end ? Date.parse(this.dataset.end) : NaN;
      this.skew = this.dataset.serverNow ? Number(this.dataset.serverNow) * 1000 - Date.now() : 0;
      this.tiles = this.querySelectorAll('[data-sg-cd]');
      if (this.tiles.length && !Number.isNaN(this.end)) {
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get step() {
      return this.track.clientWidth * 0.9;
    }

    go(direction) {
      this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
    }

    build() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.pages = max <= 4 ? 1 : Math.ceil(max / this.step) + 1;
      this.total.textContent = String(this.pages).padStart(2, '0');
      this.dots.replaceChildren();
      for (let i = 0; i < this.pages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sg-bs__dot';
        dot.setAttribute('aria-label', `${this.dataset.pageLabel} ${i + 1}`);
        dot.addEventListener('click', () => this.track.scrollTo({ left: i * this.step, behavior: 'smooth' }));
        this.dots.append(dot);
      }
      this.update();
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const page = max <= 4 ? 0 : Math.min(this.pages - 1, Math.round(this.track.scrollLeft / this.step));
      this.current.textContent = String(page + 1).padStart(2, '0');
      [...this.dots.children].forEach((d, i) => d.setAttribute('aria-current', String(i === page)));
      this.prev.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = this.track.scrollLeft >= max - 4;
    }

    tick() {
      const total = Math.max(0, Math.floor((this.end - (Date.now() + this.skew)) / 1000));
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      this.tiles.forEach((tile) => {
        const text = String(parts[tile.dataset.sgCd]).padStart(2, '0');
        const num = tile.querySelector('.sg-cd__num');
        if (num.textContent === text) return;
        const first = !tile.dataset.ready;
        num.textContent = text;
        tile.dataset.ready = 'true';
        if (first) return;
        tile.classList.remove('is-tick');
        void tile.offsetWidth;
        tile.classList.add('is-tick');
      });
      if (total === 0) clearInterval(this.timer);
    }
  }

  customElements.define('sg-bestsellers', SgBestsellers);
}
